module.exports = __webpack_public_path__ + "img/looks.a84dad19.png";